import { useState } from "react";
import {
  ArrowRight,
  ExternalLink,
  Eye,
  EyeOff,
  KeyRound,
  ShieldCheck,
} from "lucide-react";

function ApiKeyScreen({ onSubmit }) {
  const [apiKey, setApiKey] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const normalizedApiKey = apiKey.trim();

  function handleSubmit(event) {
    event.preventDefault();
    if (normalizedApiKey) onSubmit(normalizedApiKey);
  }

  return (
    <div className="api-key-screen">
      <header className="api-key-brand">
        <span className="brand-mark" aria-hidden="true">
          W
        </span>
        <strong>词境 Wordscape</strong>
      </header>

      <main className="api-key-main">
        <div className="api-key-symbol" aria-hidden="true">
          <KeyRound size={28} strokeWidth={1.8} />
        </div>
        <p className="section-kicker">PRIVATE SESSION</p>
        <h1>连接 OpenAI</h1>
        <p className="api-key-intro">
          输入你的 OpenAI API Key，开始生成专属 TOEFL 阅读练习。
        </p>

        <form className="api-key-form" onSubmit={handleSubmit}>
          <label htmlFor="openai-api-key">OpenAI API Key</label>
          <div className="api-key-input-wrap">
            <KeyRound aria-hidden="true" size={18} strokeWidth={1.8} />
            <input
              id="openai-api-key"
              name="openai-api-key"
              type={isVisible ? "text" : "password"}
              value={apiKey}
              autoComplete="off"
              autoFocus
              spellCheck="false"
              placeholder="sk-..."
              onChange={(event) => setApiKey(event.target.value)}
            />
            <button
              type="button"
              aria-label={isVisible ? "隐藏 API Key" : "显示 API Key"}
              title={isVisible ? "隐藏 API Key" : "显示 API Key"}
              onClick={() => setIsVisible((current) => !current)}
            >
              {isVisible ? (
                <EyeOff aria-hidden="true" size={18} strokeWidth={1.8} />
              ) : (
                <Eye aria-hidden="true" size={18} strokeWidth={1.8} />
              )}
            </button>
          </div>

          <div className="api-key-privacy">
            <ShieldCheck aria-hidden="true" size={17} strokeWidth={1.8} />
            <span>密钥仅用于当前页面会话，不会写入浏览器存储。</span>
          </div>

          <button
            type="submit"
            className="api-key-submit"
            disabled={!normalizedApiKey}
          >
            <span>进入 Wordscape</span>
            <ArrowRight aria-hidden="true" size={18} strokeWidth={2} />
          </button>
        </form>

        <a
          className="api-key-link"
          href="https://platform.openai.com/api-keys"
          target="_blank"
          rel="noreferrer"
        >
          <span>创建或管理 API Key</span>
          <ExternalLink aria-hidden="true" size={15} strokeWidth={1.8} />
        </a>
      </main>
    </div>
  );
}

export default ApiKeyScreen;
